import React from "react";
import "../../App.css";
import ReactPlayer from "react-player";

function Reel() {
  return (
    <div className="reel">
      <>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=ixzMaopvZnA&t=2s"
          width="100%"
          height="100%"
          controls={true}
        />
      </>
    </div>
  );
}

export default Reel;
